import { parse, stringify } from 'query-string';
import useStewardshipFilter from '../../sites/useStewardshipFilter';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 100, extra = {} } = props;

  const stewardshipFilter = useStewardshipFilter();

  return useConnect('site.find', {
    where: {
      eager: {
        $where: {
          networks: {
            $having: {
              count: {
                $gt: 0
              }
            }
          },
          $or: stewardshipFilter,
          // ...extra
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
